import { getLangOverrideValue, LANG_STATE_PREFIX } from "../config";

/**
 * @param { import("../config").ConfigObject} config
 * @param { SpeechSynthesisVoice[] } validVoices
 */
export function getSynthesisKey(config) {
  let lang;

  if (document.cookie.includes(LANG_STATE_PREFIX)) {
    lang = getLangOverrideValue(config);
  } else if (config.overrideLanguage) {
    lang = config.overrideLanguage;
  } else if (config?.text) {
    if (
      navigator.language in config["text"] ||
      navigator.language.split("-")[0] in config["text"]
    ) {
      lang = navigator.language;
    }
  }

  // if the detected language isn't one of the configured text languages, early
  // out.
  if (!lang) {
    return false;
  } else {
    return lang;
  }
}

export async function calculateVoice(synthKey) {
  try {
    let [langCode, regionCode] = synthKey.split("-");

    if (!regionCode) {
      regionCode = "Other";
    }

    const url =
      "https://hadriengardeur.github.io/web-speech-recommended-voices/json/" +
      langCode +
      ".json";
    const response = await fetch(url);
    const jsonData = await response.json();
    if (!jsonData) return [];

    let availableVoices = [];

    // get all locally available system voices
    const systemVoices = speechSynthesis
      .getVoices()
      .filter((voice) => voice.localService === true);

    // reduce list to voices available on the system
    jsonData.voices.forEach(function (voice) {
      if (systemVoices.some((apiVoice) => apiVoice.name === voice.name)) {
        availableVoices.push(voice);
      } else {
        if (voice.altNames) {
          voice.altNames.forEach(function (altName) {
            if (systemVoices.some((apiVoice) => apiVoice.name === altName)) {
              voice.name = altName;
              availableVoices.push(voice);
            }
          });
        }
      }
    });

    // group voices by region code
    const regions = {};

    availableVoices.forEach((voice) => {
      const region = voice.language.split("-")[1] ?? "Other";
      if (!regions[region]) {
        regions[region] = [];
      }
      regions[region].push(voice);
    });

    let finalList = [];

    // if the user's region code is one of the available codes, prioritize
    // voices with that region
    if (regionCode && regionCode in regions) {
      finalList = [...regions[regionCode]];
      console.log("region code detected, fl is", finalList);
      delete regions[regionCode];
    }

    for (const region in regions) {
      finalList.push(...regions[region]);
    }

    if (!finalList) {
      return;
    }

    // prioritize a female voice where possible
    let finalVoice = finalList.find((voice) => voice.gender === "female");

    // if there's no female voices just return the first in the list
    finalVoice ??= finalList[0];

    return systemVoices.find(
      (systemVoice) => systemVoice.name === finalVoice.name,
    );
  } catch (error) {
    console.error("Error loading JSON data:", error);
    return;
  }
}

/**
 * @param {import("../types/config").StackEmbedConfigObject} config
 */
export function getUrlLangKey(config) {
  const firstPathSegment = window.location.pathname.split("/")?.[1];

  if (!firstPathSegment || !config?.text) {
    return;
  }

  const configuredKeys = Object.keys(config.text);
  if (configuredKeys.length < 1) {
    return;
  }

  if (configuredKeys.includes(firstPathSegment)) {
    return firstPathSegment;
  } else if (firstPathSegment.includes("-")) {
    const prefix = firstPathSegment.split("-")[0];
    if (configuredKeys.includes(prefix)) {
      return prefix;
    }
  }
  return;
}
